import { createAuth0 } from '@auth0/auth0-vue';

const url = new URL(window.location.href);
const organization = url.host.split('.')[0];

let authorizationParams = {
  redirect_uri: window.location.origin + '/callback',
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  scope: 'openid, profile, email, offline_access',
  grant_type: 'authorization_code',
  response_type: 'code',
};

if (!['dev', 'staging', 'arcane', 'localhost:3000'].includes(organization)) {
  authorizationParams = { ...authorizationParams, organization };
}

const auth0Client = createAuth0({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  cacheLocation: 'localstorage',
  responseType: 'code',
  grantType: 'authorization_code',
  legacySameSiteCookie: false,
  cookieDomain: '.anthill.technology',
  authorizationParams,
});

export default auth0Client;
